__turbopack_context__.v({
  "mediaFallback": "ReviewMediaPreview-module-scss-module__mvcLLa__mediaFallback",
  "mediaPlayIcon": "ReviewMediaPreview-module-scss-module__mvcLLa__mediaPlayIcon",
  "mediaPreview": "ReviewMediaPreview-module-scss-module__mvcLLa__mediaPreview",
});
